/* istanbul ignore file: tested manually */
import throttle from 'lodash.throttle';
import { useEffect } from 'react';

const DELAY = 100;
/**
 * A small offset value (1 pixel) added to the top position check during
 * scrolling. This compensates for a slight margin of error and prevents
 * false positives in detecting whether an element is at the top of the
 * screen.
 */
const SCREEN_TOP = 1;

const setHash = (hash: string) => {
  const x = window.scrollX;
  const y = window.scrollY;

  window.location.replace(hash);

  // Restore the scroll position after changing the hash
  window.scroll(x, y);
};

const resetHash = () => {
  setHash('#');

  // Remove the '#' from the URL
  history.replaceState(null, document.title, window.location.pathname + window.location.search);
};

export const useAnchorToHashOnScroll = (anchors: string[], { disabled } = { disabled: false }) => {
  useEffect(() => {
    if (disabled) return;

    const onScroll = () => {
      const anchor = anchors.findLast(anchor => {
        const element = document.getElementById(anchor);
        if (!element) return false;
        const elementTop = element.getBoundingClientRect().top;
        if (elementTop > SCREEN_TOP) return false;
        return true;
      });

      if (!anchor) {
        resetHash();
        return;
      }

      const newHash = '#' + anchor;
      const oldHash = window.location.hash;
      if (newHash !== oldHash) setHash(newHash);
    };

    const handleScroll = throttle(onScroll, DELAY);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [anchors, disabled]);
};
